// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

document.addEventListener("DOMContentLoaded", () => {
    document.documentElement.classList.remove("no-javascript");
});
